import { render, staticRenderFns } from "./initial-loader-scenario-step.vue?vue&type=template&id=0a9e8979&scoped=true"
import script from "./initial-loader-scenario-step.vue?vue&type=script&lang=ts"
export * from "./initial-loader-scenario-step.vue?vue&type=script&lang=ts"
import style0 from "./initial-loader-scenario-step.vue?vue&type=style&index=0&id=0a9e8979&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e8979",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9e8979')) {
      api.createRecord('0a9e8979', component.options)
    } else {
      api.reload('0a9e8979', component.options)
    }
    module.hot.accept("./initial-loader-scenario-step.vue?vue&type=template&id=0a9e8979&scoped=true", function () {
      api.rerender('0a9e8979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/steps/initial-loader-scenario-step.vue"
export default component.exports